module.exports = __webpack_public_path__ + "img/home-title5.7130605c.png";